import React, { useState } from "react"
// @ts-ignore
import * as s from "./dropdownInput.module.scss"

interface Option {
  value: string
}

interface DropdownInputProps {
  options: Option[]
  name: string
  label: string
  value: string
  onChange: (name: string, value: string) => void
  className?: string
  required: boolean
  isOpen: boolean
  setOpenDropdown: (name: string | null) => void
}

const DropdownInput: React.FC<DropdownInputProps> = ({ options, name, label, value, onChange, className = "", required, isOpen, setOpenDropdown }) => {
  const selectedOption = options.find((opt) => opt.value === value)

  const handleSelect = (selectedValue: string) => {
    onChange(name, selectedValue)
    setOpenDropdown(null)
  }

  return (
    <div className={`dropdown-container ${s.customPlaceholder} ${className}`} onClick={() => setOpenDropdown(isOpen ? null : name)}>
      <div className={`${s.inputContainer} ${isOpen ? s.inputContainer_active : ""}`} onClick={() => setOpenDropdown(isOpen === name ? null : name)}>
        <label htmlFor={name} className={`${s.customLabel} ${selectedOption ? s.hidden : ""}`}>
          {label}
          {required && <span className={s.required}>*</span>}
        </label>
        <input type="text" id={name} name={name} value={selectedOption ? selectedOption.value : ""} readOnly className={`${selectedOption ? s.success : ""}`} />
        <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L8.29289 8.29289C8.68342 8.68342 9.31658 8.68342 9.70711 8.29289L17 1" stroke="#717171" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>
      {isOpen && (
        <div>
          <ul className={s.dropdown}>
            {options.map((option) => (
              <li key={option.value} className={s.dropdownItem} onClick={() => handleSelect(option.value)}>
                <span>{option.value}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default DropdownInput
